import React from 'react'
import { camelCase, kebabCase } from 'lodash'

import {
  IProps as IFeatureSpotlight,
  FeatureSpotlight,
} from 'marketing-site/src/mvp/library/components/FeatureSpotlight'
import {
  CONTENT_TYPE,
  IFeatureSpotlightMvp as IContentfulFeatureSpotlight,
} from 'marketing-site/@types/generated/contentful'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import { renderTransformedComponent } from 'marketing-site/lib/transformedComponents'
import { transformMediaContent } from 'marketing-site/src/transformers/elements/ContentfulMedia'

export const ContentfulFeatureSpotlight = (
  featureSpotlight: IContentfulFeatureSpotlight,
): React.ReactElement => {
  return (
    <EntryMarker entry={featureSpotlight}>
      {() => <FeatureSpotlight {...transformFeatureSpotlight(featureSpotlight)} />}
    </EntryMarker>
  )
}

const transformMedia = (
  media:
    | IContentfulFeatureSpotlight['fields']['icon']
    | IContentfulFeatureSpotlight['fields']['media'],
) => {
  if (!media) return
  const contentTypeId = media?.sys.contentType?.sys.id as CONTENT_TYPE
  return renderTransformedComponent(contentTypeId, media)
}

const transformCTAs = (content: IContentfulFeatureSpotlight['fields']['ctas']) => {
  const filteredContent = content?.map((item) => {
    const contentTypeId = item.sys.contentType?.sys.id as CONTENT_TYPE
    return renderTransformedComponent(contentTypeId, item)
  })
  return filteredContent
}

export function transformFeatureSpotlight({
  fields,
}: IContentfulFeatureSpotlight): IFeatureSpotlight {
  return {
    ...fields,
    layout: fields.layout && (kebabCase(fields.layout) as IFeatureSpotlight['layout']),
    theme: fields.theme && (kebabCase(fields.theme) as IFeatureSpotlight['theme']),
    icon: fields.icon && transformMedia(fields.icon),
    ctas: fields.ctas && (transformCTAs(fields.ctas) as IFeatureSpotlight['ctas']),
    media: transformMediaContent(fields.media),
    mediaType: fields.media.sys.contentType.sys.id,
    backgroundColor:
      fields.backgroundColor &&
      (camelCase(fields.backgroundColor) as IFeatureSpotlight['backgroundColor']),
  }
}
